/**
 * 複写するマニフェスト
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/manifests`

 const duplicate_manifest = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/duplicates`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},

 }

 export default duplicate_manifest
